import SEOHeader from './SEOHeader';

export { SEOHeader };
